import { getValue, curry, curryPartner } from './helpers';

function fnPreTaxMemberContributions(modifier) {
  return function PreTaxMemberContributions() {
    const frequency = getValue(this, `inferred.PreTaxMemberContributionsFrequency${modifier}`);
    return frequency === 1 ? 100 : 50;
  };
}
export const PreTaxMemberContributions = curry(fnPreTaxMemberContributions);
export const PreTaxMemberContributions2 = curryPartner(fnPreTaxMemberContributions);

function fnPostTaxMemberContributions(modifier) {
  return function PostTaxMemberContributions() {
    const frequency = getValue(this, `inferred.PostTaxMemberContributionsFrequency${modifier}`);
    return frequency === 1 ? 100 : 50;
  };
}
export const PostTaxMemberContributions = curry(fnPostTaxMemberContributions);
export const PostTaxMemberContributions2 = curryPartner(fnPostTaxMemberContributions);
